import React from 'react';
import PropTypes from 'prop-types';

import { Button, Icon, Label } from '@atlas/ui';

import { OAUTH_FLOW_TYPES } from 'common/constants';
import FormWithCaptcha from 'common/Form/FormWithCaptcha/FormWithCaptcha';
import Stepper from 'components/Stepper/Stepper';
import SocialProviders from 'src/components/Auth/SocialProviders';

const SignUpFormBody = ({
  action,
  activeStep,
  activeType,
  fields = undefined,
  flowType,
  isBackButtonVisible,
  isLastStep = false,
  onBackButtonClick,
  onTrackedFieldChanges,
  shouldShowStepper,
  showSignInLink,
  signInContainerClassName = 'links',
  signInContent,
  socialProviders = [],
  stepsAmount = 0,
  trackedFields,
}) => (
  <>
    {shouldShowStepper && <Stepper activeStep={activeStep} stepsAmount={stepsAmount} />}

    <FormWithCaptcha
      action={action}
      buttonId="signUp"
      buttonText={isLastStep ? 'Registration' : 'Next'}
      form={{ fields, number: activeStep }}
      formType={activeType}
      id={activeType.id}
      initialCaptchaKey={activeType?.optionalParams?.captchaKey}
      initialCaptchaRequired={activeType?.optionalParams?.captchaRequired}
      isSubmitButtonAlwaysEnabled
      key={activeType.id}
      leftSideSubmitContent={
        isBackButtonVisible && (
          <Button
            className="step-back-button"
            onClick={onBackButtonClick}
            size="big"
            type="secondary"
          >
            <Icon height={20} name="arrow-left" width={20} />
            <Label message="step_number" params={{ number: activeStep }} />
          </Button>
        )
      }
      onTrackedFieldChanges={onTrackedFieldChanges}
      trackedFields={trackedFields}
      validateRequestHeaders={{ 'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone }}
    />
    {activeStep === 0 && <SocialProviders flowType={flowType} items={socialProviders} />}
    {showSignInLink && (
      <div className={signInContainerClassName}>
        {signInContent}
      </div>
    )}
  </>
);

SignUpFormBody.propTypes = {
  action: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  activeType: PropTypes.object.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object),
  flowType: PropTypes.oneOf([OAUTH_FLOW_TYPES.SIGNUP, OAUTH_FLOW_TYPES.SIGNUP_MULTISTEP]),
  isBackButtonVisible: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool,
  onBackButtonClick: PropTypes.func.isRequired,
  onTrackedFieldChanges: PropTypes.func.isRequired,
  shouldShowStepper: PropTypes.bool.isRequired,
  showSignInLink: PropTypes.bool.isRequired,
  signInContainerClassName: PropTypes.string,
  signInContent: PropTypes.node.isRequired,
  socialProviders: PropTypes.arrayOf(PropTypes.object),
  stepsAmount: PropTypes.number,
  trackedFields: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SignUpFormBody;
